module.exports = __webpack_public_path__ + "media/images/logos/isaac-logo-small-68dec786f793c339e8d70a3d1d112de6.svg";